import { ScrollCarousel } from "theme"; // Import the original ScrollCarousel component

class InfiniteScrollCarousel extends ScrollCarousel {
  connectedCallback() {
    super.connectedCallback();
    this.initInfiniteScroll();
  }

  initInfiniteScroll() {
    this.originalCells = [...this.cells]; // Store original items

    this.isInfinite = this.shouldEnableInfiniteScroll();
    this.isInfinite && this.enableInfiniteScroll();
    this.allowDragging();
  }

  shouldEnableInfiniteScroll() {
    // Check if all items fit within the visible width
    const totalItemsWidth = this.originalCells.reduce((total, cell) => total + cell.offsetWidth, 0);
    return totalItemsWidth > this.clientWidth; // Enable only if scrolling is needed
  }

  enableInfiniteScroll() {
    // Duplicate items before and after for seamless scrolling
    this.originalCells.forEach((cell) => {
      const clone = cell.cloneNode(true);

      if (clone.classList.contains("is-initial")) clone.classList.remove("is-initial");

      clone.setAttribute("data-clone", "true");
      this.appendChild(clone);
    });

    [...this.originalCells].reverse().forEach((cell) => {
      const clone = cell.cloneNode(true);

      if (clone.classList.contains("is-initial")) clone.classList.remove("is-initial");

      clone.setAttribute("data-clone", "true");
      this.insertBefore(clone, this.firstChild);
    });

    // Ensure correct position at the start
    requestAnimationFrame(() => this.initCorrection());

    // Prevent hard jumps when reaching edges
    this.addEventListener("scroll", () => {
      requestAnimationFrame(() => this.useInfiniteScroll());
    });
  }

  previous({ instant = false } = {}) {
    this.select(this.selectedIndex - 1, { instant });
  }
  next({ instant = false } = {}) {
    this.select(this.selectedIndex + 1, { instant });
  }

  useInfiniteScroll() {
    const lastOriginalCell = this.originalCells[this.originalCells.length - 1];
    const lastCell = this.cells[this.cells.length - 1];
    const firstOriginalCell = this.originalCells[0];
    const isSingleItem = lastCell.offsetWidth >= this.clientWidth;
    const isOverflowItem =
      !isSingleItem &&
      lastCell.previousElementSibling.offsetWidth + lastCell.offsetWidth > this.clientWidth;

    const buffer = 10;
    const isAtStart = this.scrollLeft <= buffer;
    const isAtEnd = isSingleItem
      ? this.scrollLeft + this.clientWidth >= lastCell.offsetLeft + lastCell.offsetWidth - buffer
      : isOverflowItem
      ? this.scrollLeft + this.clientWidth >= lastCell.offsetLeft
      : this.scrollLeft + this.clientWidth >= lastCell.offsetLeft - 25;

    if (isAtStart) {
      this.style.scrollSnapType = "none";
      if (isOverflowItem) {
        this.scrollLeft = firstOriginalCell.offsetLeft - buffer;
      } else {
        this.scrollLeft = firstOriginalCell.offsetLeft;
      }
      setTimeout(() => (this.style.scrollSnapType = "x mandatory"));
    } else if (isAtEnd) {
      this.style.scrollSnapType = "none";
      if (isSingleItem) {
        this.scrollLeft = lastOriginalCell.offsetLeft;
      } else if (isOverflowItem) {
        this.scrollLeft =
          lastOriginalCell.offsetLeft - lastOriginalCell.previousElementSibling.offsetWidth - 50;
      } else {
        this.scrollLeft = lastOriginalCell.offsetLeft - this.clientWidth;
      }
      setTimeout(() => (this.style.scrollSnapType = "x mandatory"));
    }
  }
  initCorrection() {
    this.scrollLeft = this.originalCells[0].offsetLeft;
  }

  allowDragging() {
    this.addEventListener("mousedown", (e) => {
      if (e.target.closest("product-card")) e.preventDefault();
    });
  }
}

window.customElements.define("infinite-scroll-carousel", InfiniteScrollCarousel);
